/* eslint-env browser */
import { Collapsable, StatefulLoader } from '@mauriceguest/guest'
import SignupFormController from './SignupFormController'

export default class SignupFormComponent {
 render(props) {
  const { el } = this
  SignupFormController.control(el, {props})
 }
 constructor(el) {
  this.el = el
 }
}
SignupFormComponent['plain'] = true

export { SignupFormController }

/** @constructor @extends {SignupFormController} @suppress {checkTypes} */ function _SignupFormController() {}
SignupFormController.__implement(StatefulLoader, Collapsable,
 _SignupFormController.prototype = /** @type {!SignupFormController} */ ({
  ready() {
   const { NameInput, PhoneInput, PasswordInput } = this
   // automatically apply models on forms
   NameInput.addEventListener('input', () => {
    this.userLoader.resetLoadingState()
   })
   PhoneInput.addEventListener('input', () => {
    this.userLoader.resetLoadingState()
   })
   PasswordInput.addEventListener('input', () => {
    this.userLoader.resetLoadingState()
   })
  },
  async createUser() {
   const{FormSignup,
    asIUserLoaderer:{userLoader:{asIUserLoader:{SignUp}}},
    asIStateful:{setState},
   }=this
   const isValid = FormSignup.reportValidity()
   if (!isValid) return

   const user = await SignUp(FormSignup)
   if(user) {
    setState({
     success:true,
    })
    window['ym'](89137587,'reachGoal','CompleteSignup')
    setTimeout(()=>{
     const ce=new CustomEvent('signup')
     ce.user=user
     this.dispatchEvent(ce)
     window.dispatchEvent(new CustomEvent('signup'))
    },10)
   }
  },
  paint() {
   const {
    userLoader:{state:{errorText:errorText}},
    state:{success},
    RegisterError,RegisterSuccess,
   } = this

   if(errorText) RegisterError.innerHTML = errorText
   else RegisterError.innerText = ''

   if (success) RegisterSuccess.innerText = 'Успех!'
   else RegisterSuccess.innerText = ''
  },
 }),
)